import { render, staticRenderFns } from "./OfertaCreate.vue?vue&type=template&id=5d318138&scoped=true&"
import script from "./OfertaCreate.vue?vue&type=script&lang=js&"
export * from "./OfertaCreate.vue?vue&type=script&lang=js&"
import style0 from "./OfertaCreate.vue?vue&type=style&index=0&id=5d318138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d318138",
  null
  
)

export default component.exports